export default "__VITE_ASSET__1sUTgezm__"